
import { Component, Vue } from 'vue-property-decorator'
import PasswordReset from '@/components/templates/password/PasswordReset.vue'
import PasswordUtils from '@/utils/PasswordUtils'
import { ApiNotFoundAppError } from '@/models/AppErrorClasses'
import { PasswordsApi } from '@/api/methods/auth/PasswordsApi'

/**
 * パスワード再設定ページ
 */
@Component({
  components: {
    PasswordReset,
  },
})
export default class StudentPasswordReset extends Vue {
  /** 読み込み完了フラグ */
  private isLoaded = false

  /**
   * クエリのトークン情報取得
   *
   * @returns クエリのトークン情報
   */
  private get token(): string {
    const token = this.$route.query.token
    if (!token || typeof token !== 'string') {
      // トークン未指定時、指定不正時は空文字列を返す
      return ''
    }
    return token
  }

  /**
   * 初期処理
   */
  private async mounted(): Promise<void> {
    // トークン指定不正時はエラー画面に遷移
    if (this.token === '') {
      this.$router.push('/student/password/reset/error')
      return
    }

    // トークンの有効判定を行う
    try {
      await PasswordsApi.checkToken(this.token)
    } catch (error) {
      // トークン無効時はエラー画面に遷移
      if (error instanceof ApiNotFoundAppError) {
        await this.$router.push('/student/password/reset/error')
        return
      }

      // 404エラー以外の場合は例外を投げ直し、共通処理に渡す
      throw error
    }

    // フラグを有効化し、画面を表示
    this.isLoaded = true
  }

  /**
   * 送信ボタン押下時処理
   *
   * @param password パスワード
   * @param confirmPassword パスワード(確認用)
   */
  public async eventSubmit(password: string, confirmPassword: string): Promise<void> {
    this.$loading.start()

    if (password !== confirmPassword) {
      alert('新しいパスワードと確認用パスワードが一致しません。')
      this.$loading.complete()
      return
    }

    // パスワード指定が適切かのチェック
    const errorMessage = PasswordUtils.checkPasswordEnabled(password)
    if (errorMessage) {
      alert(errorMessage)
      this.$loading.complete()
      return
    }

    // パスワード更新処理
    try {
      await PasswordsApi.updatePassword(password, this.token)
    } catch (error) {
      // トークン無効時はエラー画面に遷移
      if (error instanceof ApiNotFoundAppError) {
        this.$loading.complete()
        await this.$router.push('/student/password/reset/error')
        return
      }

      // 404エラー以外の場合は例外を投げ直し、共通処理に渡す
      throw error
    }

    this.$loading.complete()

    await this.$router.push('/student/password/reset/complete')
  }
}
